import styled from 'styled-components';
import { useProcContext } from '@/entities/proc';
import { EditComponentView } from './EditComponentView';
import { EditProcSidebarRightTabs } from './EditProcSidebarRightTabs';

export const EditProcSidebar = () => {
  const { selectedComponent } = useProcContext();

  return (
    <SidebarWrapper>
      {selectedComponent ? <EditComponentView /> : <EditProcSidebarRightTabs />}
    </SidebarWrapper>
  );
};

const SidebarWrapper = styled.div`
  height: 100%;
`;
